/**
 * created by tian ruo jun
 阿里图标库
 *
 */
import React, {Component} from 'react';
import {Icon} from 'antd'

let IconFont = Icon.createFromIconfontCN({scriptUrl: ''});
export const setIconFont = () => {
    IconFont = Icon.createFromIconfontCN({scriptUrl: 'assets/alifont/iconfont.js'});
};
export default IconFont
